var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent } from 'vue';
import OpeningTimesBlock from '@/components/Locations/subComponents/OpeningTimesBlock.vue';
import { locationsApiClient } from '@/services/api';
export default defineComponent({
    name: 'search-location-card',
    components: { OpeningTimesBlock },
    props: {
        location: {
            type: Object,
            required: true,
        },
    },
    mounted() {
        if (this.location.opening_times.length) {
            this.openingTimes = this.location.opening_times;
            return;
        }
        locationsApiClient.queryLocation(this.location.id).then((location) => __awaiter(this, void 0, void 0, function* () {
            const queriedOpeningTimes = location === null || location === void 0 ? void 0 : location.opening_times;
            if (queriedOpeningTimes === undefined) {
                return;
            }
            this.openingTimes = queriedOpeningTimes;
        }));
    },
    data() {
        return {
            openingTimes: [],
        };
    },
    computed: {
        link() {
            return ('https://www.google.com/maps/embed/v1/place?q=' +
                this.location.street_name +
                ' ' +
                this.location.street_number +
                ' ' +
                this.location.zip_code +
                ' ' +
                this.location.city +
                '&key=AIzaSyAj4q9xWcQ_PEY1l4kpla59CB8LwTRimH4');
        },
    },
});
